import * as tslib_1 from "tslib";
import { Spinner, SpinnerType } from 'office-ui-fabric-react/lib/Spinner';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
var styles = require('./OptionsPaneLoading.scss');
var OptionsPaneLoading = /** @class */ (function (_super) {
    tslib_1.__extends(OptionsPaneLoading, _super);
    function OptionsPaneLoading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OptionsPaneLoading.prototype.render = function () {
        return (React.createElement("div", { className: styles.messageContainer },
            React.createElement("div", null,
                React.createElement(Spinner, { type: SpinnerType.large })),
            React.createElement("div", { className: styles.messageText }, strings.optionsFull_subCategory_loading)));
    };
    return OptionsPaneLoading;
}(React.Component));
export default OptionsPaneLoading;
//# sourceMappingURL=OptionsPaneLoading.js.map